import {
    AfterViewInit,
    Component,
    ElementRef,
    HostBinding,
    Input,
    OnInit,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { IconComponent } from "../../components/icon/icon.component";
import { IValidationRule } from "../IValidationRule";

@Component({
    selector: "rask-validation-message-popover",
    templateUrl: "./validation-message-popover.component.html",
    styleUrls: ["./validation-message-popover.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [IconComponent]
})
export class ValidationMessagePopoverComponent implements OnInit, AfterViewInit {
    @HostBinding("class.error") error = false;
    icon: string;
    @HostBinding("class.info") info = false;
    message: string;
    @Input() rule: IValidationRule;
    @HostBinding("class.warning") warning = false;

    private readonly elementRef = inject(ElementRef);

    ngAfterViewInit(): void {
        const nativeElement = this.elementRef.nativeElement;
        const style = window.getComputedStyle(nativeElement);
        const height = parseInt(style.height, 10);
        const marginTop = Math.floor((height - 14) / 2);
        nativeElement.style.setProperty("--margin-top", `${marginTop}px`);
    }

    ngOnInit(): void {
        this.message = this.rule.message.text;

        if (this.rule.hasWarning) {
            this.warning = true;
            this.icon = "fal fa-exclamation-square";
        } else if (this.rule.hasError) {
            this.error = true;
            this.icon = "fal fa-exclamation-circle";
        } else {
            this.info = true;
            this.icon = "fal fa-info-circle";
        }
    }
}
